import angular from 'angular';
;
export default angular.module('tkr.custom', [])
    .value('customizationConfig', {})
    .name;
